import { css } from 'emotion';

export const root = css`
  position: fixed;
  border-radius: 4px;
  box-shadow: 0 12px 24px 0 #2231421a, 0 1px 3px 0 rgba(34, 47, 66, 0.15);
  background-color: #ffffff;
  z-index: 50;
  display: flex;
  resize: both;
  overflow: auto;
  padding-bottom: 10px;

  &.visible {
    transform: scale(1);
    width: 404px;
    height: 525px;
    top: 100px;
    left: 100px;
    transition: 0.3s ease-in all;
  }
  &.visible.no-transition {
    transition: none;
  }
  &.invisible {
    transform: scale(0);
    width: 0px;
    height: 0px;
    top: 35px;
    left: calc(100vw - 50px);
    transition: 0.3s ease-out all;
  }
`;
